export default __webpack_public_path__ + "static/media/plain-sticker-7.2347a3ce.png";